// import

import * as R from 'ramda';
import {useCallback} from 'react';

import api from 'engines/hubApi';
import {recaptcha} from 'modules/Recaptcha';

// vars

const defGroups = [process.env.MAILERLITE_GROUP_DEFAULT];

// hook

export function useSignupSubmit(groups = defGroups, parseSubmit = R.identity) {
  return useCallback(async (values) => {
    const token = await recaptcha();
    const body = parseSubmit({
      ...values,
      groups,
      recaptcha: token,
    });

    return api('/list/signup', {method: 'POST', body});
  }, []);
}
